import React, { useState, useEffect } from "react";
import '../App.css';
import { Link } from 'react-router-dom';
import { useClient } from '../context/ClientContext.tsx';
import { GenericDbCall, clearByPartitionKey } from '../components/LambdaApi.js';

import { useDialog } from "../hooks/useDialog";



const Admin = () => {
    const { organization, expirationDate } = useClient();
    const [emailList, setEmailList] = useState([]);
    const [newEmail, setNewEmail] = useState('');
    const [newIsAdmin, setNewIsAdmin] = useState(false);
    const [newIsActive, setNewIsActive] = useState(true);
    const [loading, setLoading] = useState(true);
    const [subscriptionInfo, setSubscriptionInfo] = useState(null);

    useEffect(() => {
        async function fetchUsers() {
            try {
                const getPayload = {
                    table: "users",
                    operation: "query",
                    query: {
                        ClientCode: { S: organization }
                    }
                };

                const result = await GenericDbCall(getPayload);
                const users = result?.Items || [];

                const filtered = users.map(item => ({
                    email: item.Email?.S || '',
                    isAdmin: item.IsAdmin?.BOOL || false,
                    isActive: item.IsActive?.BOOL !== false // default to true
                }));

                setEmailList(filtered);

                // Fetch subscriptions
                const subPayload = {
                    table: "subscriptions",
                    operation: "query",
                    query: {
                        ClientCode: { S: organization }
                    }
                };

                const subResult = await GenericDbCall(subPayload);
                const subs = subResult?.Items || [];
                if (subs.length > 0) {
                    const sortedSubs = subs.sort((a, b) => new Date(b.updated_at?.S || 0) - new Date(a.updated_at?.S || 0));
                    const sub = sortedSubs[0];
                    setSubscriptionInfo({
                        status_formatted: sub.status_formatted?.S || '',
                        renews_at: sub.renews_at?.S || '',
                        variant_name: sub.variant_name?.S || '',
                        ends_at: sub.ends_at?.S || null,
                    });
                } else {
                    setSubscriptionInfo(null);
                }
            } catch (error) {
                console.error("Error loading users:", error);
            } finally {
                setLoading(false);
            }
        }

        if (organization) {
            fetchUsers();
        }
    }, [organization]);

    const handleAddOrUpdate = () => {
        if (!newEmail.trim()) return;

        const updatedList = [...emailList];
        const newEntry = {
            email: newEmail,
            isAdmin: newIsAdmin,
            isActive: newIsActive
        };

        updatedList.push(newEntry);

        setEmailList(updatedList);
        setNewEmail('');
        setNewIsAdmin(false);
        setNewIsActive(true);
    };

    const { confirm, alert, Dialog } = useDialog();
    const handleClearQueue = async () => {
        // replace window.confirm with your custom confirm
        const confirmed = await confirm(
            "Confirm clear all queue records. This cannot be undone."
        );
        if (!confirmed) return;

        const result = await clearByPartitionKey({
            table: "queue",
            partitionKeyName: "ClientCode",
            partitionKeyValue: organization,
            sortKeyName: "InsertDtm"
        });

        // replace window.alert with your custom alert
        // this is the raw api response - too technical for users
        //await alert(result.body);

        // Normalize the response
        const isSuccess = result?.statusCode >= 200 && result?.statusCode < 300;

        if (isSuccess) {
            await alert("Queue cleared successfully.");
        } else {
            await alert("Failed to clear queue. Please try again or manually clear each row.");
        }


    };

    /*
        const handleClearQueue = async () => {
            const confirmed = window.confirm("Are you sure to clear all queue records? This cannot be undone.");
            alert(confirmed ? "You pressed OK!" : "You canceled!");
            if (!confirmed) return;
    
            const result = await clearByPartitionKey({
                table: "queue",
                partitionKeyName: "ClientCode",
                partitionKeyValue: organization
            });
    
            alert(result.body);
    
        };
    */

    const handleSaveAll = async () => {
        const clientCode = organization || "UnknownOrg";

        for (const entry of emailList) {
            let existing = {};
            try {
                const getPayload = {
                    table: "users",
                    operation: "get",
                    key: {
                        UserId: { S: entry.email }
                    }
                };
                const result = await GenericDbCall(getPayload);
                existing = result || {};
            } catch (error) {
                console.warn(`Could not fetch existing data for ${entry.email}`);
            }

            const item = {
                UserId: { S: entry.email },
                ClientCode: { S: existing.ClientCode?.S || clientCode },
                Username: { S: existing.Username?.S || entry.email.split('@')[0] },
                Email: { S: existing.Email?.S || entry.email },
                IsActive: { BOOL: entry.isActive },
                IsAdmin: { BOOL: entry.isAdmin },
            };

            if (existing.FirstLoginDatetime?.S) {
                item.FirstLoginDatetime = { S: existing.FirstLoginDatetime.S };
            }
            if (existing.LastLoginDatetime?.S) {
                item.LastLoginDatetime = { S: existing.LastLoginDatetime.S };
            }
            if (existing.CognitoUserId?.S) {
                item.CognitoUserId = { S: existing.CognitoUserId.S };
            }

            const payload = {
                table: "users",
                operation: "put",
                item
            };

            await GenericDbCall(payload);
        }

        alert("All users saved to database.");
    };

    return (
        <div className="App-header" style={{ width: '100%', padding: '20px' }}>
            <style>
                {`
                @media (max-width: 600px) {
                    .App-header { padding: 10px; }
                    button { min-width: 100px !important; padding: 10px 15px !important; font-size: 0.9em !important; }
                    input[type="email"] { font-size: 16px; } /* prevent zoom on iOS */
                    table { font-size: 0.9em; }
                    th, td { padding: 8px; }
                }
                `}
            </style>
            {/* <div style={{ position: 'relative', marginBottom: '50px', textAlign: 'center', paddingLeft: '80px', paddingRight: '80px' }}>
                <Link style={{ position: 'absolute', left: 0, color: 'white', textDecoration: 'underline', fontSize: '1.2em' }} to="/">Home</Link>
            </div> */}
            <div style={{ position: 'relative', marginBottom: '20px', textAlign: 'center', paddingLeft: '80px', paddingRight: '80px' }}>
                {/* <Link style={{ position: 'absolute', left: 0, color: 'white', textDecoration: 'none', fontSize: '1.2em' }} to="/">← Home</Link> */}
                {/* <Link style={{ position: 'absolute', left: 0, color: 'white', textDecoration: 'underline', fontSize: '1.2em' }} to="/">Home</Link> */}
                <Link style={{ color: 'white' }} to="/">Home</Link>
                <br />
                <h2 style={{ margin: 0 }}>
                    {organization && <div>Admin Page<br /><small>{organization}</small></div>}
                </h2>
            </div>

            <div style={{ display: 'flex', flexWrap: 'wrap', gap: '10px', justifyContent: 'center', marginBottom: '20px' }}>
                <button onClick={handleClearQueue} style={{ padding: '12px 20px', fontSize: '1em', minWidth: '120px' }}>
                    Clear Queue
                </button>
                <Link to="/select-plan">
                    <button style={{ padding: '12px 20px', fontSize: '1em', minWidth: '120px' }}>Plans</button>
                </Link>
            </div>
            <Dialog />

            <div style={{ fontSize: '0.9em', margin: '10px 0', color: 'rgba(255, 255, 255, 0.8)', textAlign: 'center' }}>
                {subscriptionInfo ? (
                    <span>
                        Current Subscription: {subscriptionInfo.status_formatted} - {subscriptionInfo.variant_name} - Renews {new Date(subscriptionInfo.renews_at).toLocaleDateString('en-US', { year: 'numeric', month: 'short', day: 'numeric' })}
                        {subscriptionInfo.ends_at && ` - Ends ${new Date(subscriptionInfo.ends_at).toLocaleDateString('en-US', { year: 'numeric', month: 'short', day: 'numeric' })}`}
                    </span>
                ) : (
                    expirationDate && (
                        <span>Free Trial: Expires {expirationDate.toLocaleDateString('en-US', { year: 'numeric', month: 'short', day: 'numeric' })}</span>
                    )
                )}
            </div>

            <h3 style={{ marginTop: '2rem', textAlign: 'center' }}>Manage Users</h3>

            {loading ? (
                <p>Loading users...</p>
            ) : (
                <>
                    <form onSubmit={(e) => { e.preventDefault(); handleAddOrUpdate(); }} style={{ marginBottom: '1rem', display: 'flex', flexDirection: 'column', gap: '10px', maxWidth: '400px', margin: '0 auto 1rem' }}>
                        <input
                            type="email"
                            placeholder="Enter user email"
                            value={newEmail}
                            onChange={(e) => setNewEmail(e.target.value)}
                            style={{ padding: '10px', fontSize: '1em', borderRadius: '4px', border: '1px solid #ccc' }}
                            required
                        />
                        <div style={{ display: 'flex', gap: '20px', alignItems: 'center' }}>
                            <label style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                                <input
                                    type="checkbox"
                                    checked={newIsAdmin}
                                    onChange={(e) => setNewIsAdmin(e.target.checked)}
                                    style={{ width: '20px', height: '20px' }}
                                />
                                Admin
                            </label>
                            <label style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                                <input
                                    type="checkbox"
                                    checked={newIsActive}
                                    onChange={(e) => setNewIsActive(e.target.checked)}
                                    style={{ width: '20px', height: '20px' }}
                                />
                                Active
                            </label>
                        </div>
                        <button type="submit" style={{ padding: '10px', fontSize: '1em', backgroundColor: '#4CAF50', color: 'white', border: 'none', borderRadius: '4px', cursor: 'pointer' }}>
                            Add User
                        </button>
                    </form>

                    <div style={{ overflowX: 'auto' }}>
                        <table style={{ width: '100%', borderCollapse: 'collapse', marginTop: '20px' }}>
                            <thead>
                                <tr style={{ backgroundColor: 'rgba(255, 255, 255, 0.1)' }}>
                                    <th style={{ padding: '10px', textAlign: 'left', borderBottom: '1px solid #ddd' }}>Email</th>
                                    <th style={{ padding: '10px', textAlign: 'center', borderBottom: '1px solid #ddd' }}>Admin</th>
                                    <th style={{ padding: '10px', textAlign: 'center', borderBottom: '1px solid #ddd' }}>Active</th>
                                </tr>
                            </thead>
                            <tbody>
                                {emailList.map((entry, index) => (
                                    <tr key={index} style={{ borderBottom: '1px solid #333' }}>
                                        <td style={{ padding: '10px', wordBreak: 'break-word' }}>{entry.email}</td>
                                        <td style={{ padding: '10px', textAlign: 'center' }}>
                                            <input
                                                type="checkbox"
                                                checked={entry.isAdmin}
                                                onChange={(e) => {
                                                    const updatedList = [...emailList];
                                                    updatedList[index].isAdmin = e.target.checked;
                                                    setEmailList(updatedList);
                                                }}
                                                style={{ width: '20px', height: '20px' }}
                                            />
                                        </td>
                                        <td style={{ padding: '10px', textAlign: 'center' }}>
                                            <input
                                                type="checkbox"
                                                checked={entry.isActive}
                                                onChange={(e) => {
                                                    const updatedList = [...emailList];
                                                    updatedList[index].isActive = e.target.checked;
                                                    setEmailList(updatedList);
                                                }}
                                                style={{ width: '20px', height: '20px' }}
                                            />
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>

                </>
            )}


            {/*
            <h3 style={{ marginTop: '2rem' }}>Subscription Info</h3>
            {subscriptionInfo ? (
                <div>
                    <p><strong>Status:</strong> {subscriptionInfo.status_formatted}</p>
                    <p><strong>Billing Cycle:</strong> {subscriptionInfo.variant_name}</p>
                    <p><strong>Renews At:</strong> {new Date(subscriptionInfo.renews_at).toLocaleDateString('en-US', {
                        year: 'numeric',
                        month: 'long',
                        day: 'numeric',
                    })}</p>
                    {subscriptionInfo.ends_at && <p><strong>Ends At:</strong> {new Date(subscriptionInfo.ends_at).toLocaleDateString('en-US', {
                        year: 'numeric',
                        month: 'long',
                        day: 'numeric',
                    })}</p>}
                </div>
            ) : (
                expirationDate && (
                    <p><strong>Free Trial Expires:</strong> {expirationDate.toLocaleDateString('en-US', {
                        year: 'numeric',
                        month: 'long',
                        day: 'numeric',
                    })}</p>
                )
            )}
            */}

            <div style={{ marginTop: '2rem', display: 'flex', justifyContent: 'center' }}>
                <button onClick={handleSaveAll} style={{ padding: '12px 24px', fontSize: '1em', backgroundColor: '#2196F3', color: 'white', border: 'none', borderRadius: '4px', cursor: 'pointer', minWidth: '120px' }}>
                    Save All Changes
                </button>
            </div>

        </div>
    );
};

export default Admin;